import React from "react";
import logo from "../Images/logo.png";
import "../CSS/Footer.css";
import LinkedIn from "../Images/LinkedIn.png";
import Dribbble from "../Images/Dribbble.png";
import Instagram from "../Images/Instagram.png";

export const Footer=()=>{
    return(
        <>
             <div className="footercontainer">
                <img src={logo} alt="logo" className="footerlogo" />
                <h1>CONTACT ME</h1>

                <div className="conatctme">
                <Reach head={"EMAIL"} body={"vishnucse57@gmail.com"}/>
                <Reach head={"MOBILE NUMBER"} body={"+91 8870105224"}/>
                <div className="socialmediaicon">
                    <h1>FOLLOW ME</h1>
                    <div className="icons">
                        <a href="https://www.linkedin.com/in/vishnu-s-330881189/" target="_blank"><img src={LinkedIn} alt="LinkedIn"/></a>
                        <a href="https://dribbble.com/Vishnu_S" target="_blank"><img src={Dribbble} alt="Dribbble"/></a>
                        <a href="https://www.instagram.com/design.studio57/" target="_blank"><img src={Instagram} alt="Instagram"/></a>
                    </div>
                </div>
           </div>
            <div className="rights">
                    <Last first={"Case Study"}/>
                    <Last first={"Experience"}/>
                    <Last first={"Contact Us"}/>
                    <div className="copy">
                    <p>@ 2023 Vishnu - All Rights are Reserved</p>
                </div>
            </div>
            </div>

        </>
    )
}

const Reach=({head, body})=>{
    return(
        <div className="contact">
            <p className="contactname">{head}</p>
            <p className="conatctdata">{body}</p>
        </div>
    )
}

const Last=({first})=>{
    return(
        <div>
            <p className="first">{first}</p>
        </div>
    )
}